let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cyG00")).then(() => parcelRequire('8eWoD'));